import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Path } from '../enums';
import { ToasterService } from '../services/toaster.service';
import { SpinnerService } from '../services/spinner.service';
import { ViewerProfileService } from '@app/pages/shared/services/viewer-profile.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly injector: Injector,
  ) {}

  private get toaster(): ToasterService {
    return this.injector.get(ToasterService);
  }

  private get spinnerService(): SpinnerService {
    return this.injector.get(SpinnerService);
  }

  private get profileService(): ViewerProfileService {
    return this.injector.get(ViewerProfileService);
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if ([403].includes(error.status)) {
          // 'Removed 401 due to affect while auth failed in login screen `get-otp` API'
          this.profileService.clearProfile();
          this.authService.logout();
          this.router.navigateByUrl(Path.SignIn);
          this.toaster.info('Your Session is expired. Please login again.');
          this.spinnerService.hideSpinner();
          return throwError(() => error);
        } else {
          return throwError(() => error);
        }
      }),
    );
  }
}
